export enum Service_Status {
  Active = "Active",
  Suspended = "Suspended",
  Dunning_Suspended = "Dunning Suspended",
}

// TaaS reports the service status as a single letter rather than the words
// above. Only these two are confirmed from production data: "A" on an active
// service and "M" on a suspended one. Any other code is treated as inactive
// rather than guessed at, so the customer is stopped instead of being allowed
// to raise a ticket on a line we cannot diagnose.
export enum Service_Status_Code {
  Active = "A",
  Suspended = "M",
}

export enum Service_Stop_Message_Type {
  TOS_Account_Due_To_exceed_Credit_Limit = "TOSAccountDueToexceedCreditLimit",
  Account_Due_To_Non_Payment = "accountDueToNonPayment",
  TOS_Account_Due_To_Voluntary_Suspension = "TOSAccountDueToVoluntarySuspension",
  Account_Inactive = "accountInactive",
}

export enum STT_R2_Class_Matrix_Connection_Failure {
  OFFLINE_CPE_CHECK = "OFFLINE_CPE CHECK",
  OFFLINE_SPEED_MISMATCH = "OFFLINE_SPEED MISMATCH",
  OFFLINE_BAD_NEIGHBOUR_SPEED_MISMATCH = "OFFLINE_BAD NEIGHBOUR_SPEED MISMATCH",
  OFFLINE_SPEED_NOT_ACHIEVED = "OFFLINE_SPEED NOT ACHIEVED",
  OFFLINE_SPEED_NOT_ACHIEVED_SPEED_MISMATCH = "OFFLINE_SPEED NOT ACHIEVED_SPEED MISMATCH",
  OFFLINE_FREQ_DC_SPEED_MISMATCH = "OFFLINE_FREQ DC_SPEED MISMATCH",
  OFFLINE_SPEED_NOT_ACHIEVED_BAD_NEIGHBOUR_SPEED_MISMATCH = "OFFLINE_SPEED NOT ACHIEVED_BAD NEIGHBOUR_SPEED MISMATCH",
  OFFLINE_FREQ_DC_SPEED_NOT_ACHIEVED = "OFFLINE_FREQ DC_SPEED NOT ACHIEVED",
  OFFLINE_FREQ_DC_BAD_NEIGHBOUR = "OFFLINE_FREQ DC_BAD NEIGHBOUR",
  OFFLINE_FREQ_DC_SPEED_NOT_ACHIEVED_SPEED_MISMATCH = "OFFLINE_FREQ DC_SPEED NOT ACHIEVED_SPEED MISMATCH",
  OFFLINE_FREQ_DC_SPEED_NOT_ACHIEVED_BAD_NEIGHBOUR = "OFFLINE_FREQ DC_SPEED NOT ACHIEVED_BAD NEIGHBOUR",
  OFFLINE__SPEED_NOT_ACHIEVED = "OFFLINE__SPEED NOT ACHIEVED",
  OFFLINE_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED = "OFFLINE_BAD NEIGHBOUR_SPEED NOT ACHIEVED",
  OFFLINE_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_BAD_NEIGHBOUR = "OPER DOWN_BAD NEIGHBOUR",
  OPER_DOWN_FREQ_DC_CHECK_BTU = "OPER DOWN_FREQ DC_CHECK BTU",
  OPER_DOWN_BAD_NEIGHBOUR_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD NEIGHBOUR_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_CHECK_BTU = "OPER DOWN_CHECK BTU",
  OPER_DOWN_FREQ_DC_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED_SPEED_NOT_ACHIEVED = "OPER DOWN_FREQ DC_BAD NEIGHBOUR_SPEED NOT ACHIEVED_SPEED NOT ACHIEVED",
  OPER_DOWN_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD NEIGHBOUR_SPEED NOT ACHIEVED",
  OPER_DOWN__SPEED_NOT_ACHIEVED = "OPER DOWN__SPEED NOT ACHIEVED",
  OPER_DOWN_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OPER DOWN_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_FREQ_DC_BAD_NEIGHBOUR = "OPER DOWN_FREQ DC_BAD NEIGHBOUR",
  OFFLINE_FREQ_DC_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_FREQ DC_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OFFLINE_BAD_NEIGHBOUR_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_BAD NEIGHBOUR_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OFFLINE__SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE__SPEED MISMATCH_SPEED NOT ACHIEVED",
  OFFLINE_SPEED_MISMATCH_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_SPEED MISMATCH_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_SPEED_NOT_ACHIEVED = "OPER DOWN_SPEED NOT ACHIEVED",
  OFFLINE_BAD_PHYSICAL = "OFFLINE_BAD PHYSICAL",
  OFFLINE_PHYSICAL_BAD = "OFFLINE_PHYSICAL BAD",
  OFFLINE_FREQ_DC_BAD_PHYSICAL = "OFFLINE_FREQ DC_BAD PHYSICAL",
  OFFLINE_BAD_NEIGHBOUR_BAD_PHYSICAL = " OFFLINE_BAD NEIGHBOUR_BAD PHYSICAL",
  OPER_DOWN_BAD_NEIGHBOUR_BAD_PHYSICAL = "OPER DOWN_BAD NEIGHBOUR_BAD PHYSICAL",
  OPER_DOWN_SPEED_MISMATCH_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_SPEED MISMATCH_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OPER_DOWN_FREQ_DC_BAD_PHYSICAL = "OPER DOWN_FREQ DC_BAD PHYSICAL",
  OPER_DOWN_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OPER_DOWN_SPEED_MISMATCH_BAD_PHYSICAL = "OPER DOWN_SPEED MISMATCH_BAD PHYSICAL",
  OPER_DOWN_BAD_NEIGHBOUR_SPEED_MISMATCH_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD NEIGHBOUR_SPEED MISMATCH_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OFFLINE_PHYSICAL_BAD_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_PHYSICAL BAD_SPEED MISMATCH_SPEED NOT ACHIEVED",
  ADMIN_DOWN = "ADMIN DOWN",
  OPER_DOWN_FREQ_DC_BAD_NEIGHBOUR_BAD_PHYSICAL = "OPER DOWN_FREQ DC_BAD NEIGHBOUR_BAD PHYSICAL",
  OFFLINE_PHYSICAL_BAD__SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_PHYSICAL BAD__SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_BAD_PHYSICAL_SPEED_MISMATCH = "OPER DOWN_BAD PHYSICAL_SPEED MISMATCH",
  OPER_DOWN_BAD_NEIGHBOUR_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD NEIGHBOUR_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OPER_DOWN_BAD_NEIGHBOUR_SPEED_MISMATCH_BAD_PHYSICAL = "OPER DOWN_BAD NEIGHBOUR_SPEED MISMATCH_BAD PHYSICAL",
  OPER_DOWN_BAD_PHYSICAL_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD PHYSICAL_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_FREQ_DC_BAD_PHYSICAL_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OPER DOWN_FREQ DC_BAD PHYSICAL_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OFFLINE_BAD_NEIGHBOUR_BAD_PHYSICAL_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_BAD NEIGHBOUR_BAD PHYSICAL_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_FREQ_DC_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_FREQ DC_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OPER_DOWN_FREQ_DC_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OPER DOWN_FREQ DC_BAD NEIGHBOUR_SPEED NOT ACHIEVED_BAD PHYSICAL",
  OFFLINE_CPE_TROUBLESHOOT = "OFFLINE_CPE TROUBLESHOOT",
  OFFLINE_BAD_NEIGHBOUR = "OFFLINE_BAD NEIGHBOUR",
  OFFLINE_BAD_NEIGHBOUR_FREQ_DC = "OFFLINE_BAD NEIGHBOUR_FREQ DC",
  OFFLINE_FREQ_DC = "OFFLINE_FREQ DC",
}

export enum STT_R2_Class_Matrix_Access_Failure {
  OFFLINE_PHYSICAL_BAD = "OFFLINE_PHYSICAL BAD",
  OFFLINE_SPEED_NOT_ACHIEVED_SPEED_MISMATCH_BAD_PHYSICAL = "OFFLINE_SPEED NOT ACHIEVED_SPEED MISMATCH_BAD PHYSICAL",
  OFFLINE_SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OFFLINE_SPEED NOT ACHIEVED_BAD PHYSICAL",
  OFFLINE_BAD_NEIGHBOUR__SPEED_NOT_ACHIEVED_SPEED_MISMATCH_BAD_PHYSICAL = "OFFLINE_BAD NEIGHBOUR__SPEED NOT ACHIEVED_SPEED MISMATCH_BAD PHYSICAL",
  OFFLINE_SPEED_MISMATCH_BAD_PHYSICAL = "OFFLINE_SPEED MISMATCH_BAD PHYSICAL",
  OFFLINE_FREQ_DC_SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OFFLINE_FREQ DC_SPEED NOT ACHIEVED_BAD PHYSICAL",
  OFFLINE_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED_SPEED_MISMATCH_BAD_PHYSICAL = "OFFLINE_BAD NEIGHBOUR_SPEED NOT ACHIEVED_SPEED MISMATCH_BAD PHYSICAL",
  OFFLINE_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OFFLINE_BAD NEIGHBOUR_SPEED NOT ACHIEVED_BAD PHYSICAL",
  OPER_DOWN__SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OPER DOWN__SPEED NOT ACHIEVED_BAD PHYSICAL",
  OPER_DOWN_FREQ_DC_SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OPER DOWN_FREQ DC_SPEED NOT ACHIEVED_BAD PHYSICAL",
  OPER_DOWN__SPEED_NOT_ACHIEVED_SPEED_MISMTACH_BAD_PHYSICAL = "OPER DOWN__SPEED NOT ACHIEVED_SPEED MISMTACH_BAD PHYSICAL",
  OPER_DOWN_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OPER DOWN_BAD NEIGHBOUR_SPEED NOT ACHIEVED_BAD PHYSICAL",
  OFFLINE_BAD_NEIGHBOUR_BAD_PHYSICAL = "OFFLINE_BAD NEIGHBOUR_BAD PHYSICAL",
  OFFLINE_FREQ_DC_BAD_PHYSICAL = "OFFLINE_FREQ DC_BAD PHYSICAL",
  OPER_DOWN_FREQ_DC_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OPER DOWN_FREQ DC_BAD NEIGHBOUR_SPEED NOT ACHIEVED_BAD PHYSICAL",
  OPER_DOWN_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED_SPEED_MISMATCH_BAD_PHYSICAL = "OPER DOWN_BAD NEIGHBOUR_SPEED NOT ACHIEVED_SPEED MISMATCH_BAD PHYSICAL",
  OFFLINE_BAD_NEIGHBOUR_SPEED_MISMATCH_BAD_PHYSICAL = "OFFLINE_BAD NEIGHBOUR_SPEED MISMATCH_BAD PHYSICAL",
  OFFLINE_FREQ_DC_BAD_NEIGHBOUR_SPEED_NOT_ACHIEVED_BAD_PHYSICAL = "OFFLINE_FREQ DC_BAD NEIGHBOUR_SPEED NOT ACHIEVED_BAD PHYSICAL",
  OFFLINE_FREQ_DC_BAD_NEIGHBOUR_BAD_PHYSICAL = "OFFLINE_FREQ DC_BAD NEIGHBOUR_BAD PHYSICAL",
  OPER_DOWN_FREQ_DC_SPEED_NOT_ACHIEVED_SPEED_MISMATCH_BAD_PHYSICAL = "OPER DOWN_FREQ DC_SPEED NOT ACHIEVED_SPEED MISMATCH_BAD PHYSICAL",
  OFFLINE_FREQ_DC_SPEED_NOT_ACHIEVED_SPEED_MISMATCH_BAD_PHYSICAL = "OFFLINE_FREQ DC_SPEED NOT ACHIEVED_SPEED MISMATCH_BAD PHYSICAL",
  OFFLINE_FREQ_DC_SPEED_NOT_ACHIEVED_BAD_NEIGHBOUR_BAD_PHYSICAL = "OFFLINE_FREQ DC_SPEED NOT ACHIEVED_BAD NEIGHBOUR_BAD PHYSICAL",
  OPER_DOWN_BAD_NEIGHBOUR_BAD_PHYSICAL = "OPER DOWN_BAD NEIGHBOUR_BAD PHYSICAL",
  OPER_DOWN_SPEED_MISMATCH_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_SPEED MISMATCH_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OPER_DOWN_FREQ_DC_BAD_PHYSICAL = "OPER DOWN_FREQ DC_BAD PHYSICAL",
  OPER_DOWN_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OPER_DOWN_SPEED_MISMATCH_BAD_PHYSICAL = "OPER DOWN_SPEED MISMATCH_BAD PHYSICAL",
  OPER_DOWN_BAD_NEIGHBOUR_SPEED_MISMATCH_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD NEIGHBOUR_SPEED MISMATCH_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OFFLINE_PHYSICAL_BAD_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_PHYSICAL BAD_SPEED MISMATCH_SPEED NOT ACHIEVED",
  ADMIN_DOWN = "ADMIN DOWN",
  OPER_DOWN_FREQ_DC_BAD_NEIGHBOUR_BAD_PHYSICAL = "OPER DOWN_FREQ DC_BAD NEIGHBOUR_BAD PHYSICAL",
  OFFLINE_PHYSICAL_BAD__SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_PHYSICAL BAD__SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_BAD_PHYSICAL_SPEED_MISMATCH = "OPER DOWN_BAD PHYSICAL_SPEED MISMATCH",
  OPER_DOWN_BAD_NEIGHBOUR_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD NEIGHBOUR_BAD PHYSICAL_SPEED NOT ACHIEVED",
  OPER_DOWN_BAD_NEIGHBOUR_SPEED_MISMATCH_BAD_PHYSICAL = "OPER DOWN_BAD NEIGHBOUR_SPEED MISMATCH_BAD PHYSICAL",
  OPER_DOWN_BAD_PHYSICAL_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OPER DOWN_BAD PHYSICAL_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_FREQ_DC_BAD_PHYSICAL_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OPER DOWN_FREQ DC_BAD PHYSICAL_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OFFLINE_BAD_NEIGHBOUR_BAD_PHYSICAL_SPEED_MISMATCH_SPEED_NOT_ACHIEVED = "OFFLINE_BAD NEIGHBOUR_BAD PHYSICAL_SPEED MISMATCH_SPEED NOT ACHIEVED",
  OPER_DOWN_FREQ_DC_BAD_PHYSICAL_SPEED_NOT_ACHIEVED = "OPER DOWN_FREQ DC_BAD PHYSICAL_SPEED NOT ACHIEVED",
}

export enum Color_Code {
  "RED" = "RED",
  "GREY" = "GREY",
  "GREEN" = "GREEN",
  "YELLOW" = "YELLOW",
}

export enum Offer_Manual {
  "N" = "N",
}
export enum Offer_Livechat {
  "T" = "T",
}

export enum Services {
  Internet = "Internet",
  Voice = "Voice",
  HyppTV = "HyppTV",
}
